import { render, staticRenderFns } from "./Swipers.vue?vue&type=template&id=3c53c406&scoped=true"
import script from "./Swipers.vue?vue&type=script&lang=js"
export * from "./Swipers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53c406",
  null
  
)

export default component.exports